// libs
import { connect } from 'react-redux';

// selectors
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';
import { isLoggedIn, isUserFetching } from 'shared/store/app/selectors';
import { getShowAnimationForProductId, isProductInWishlist } from 'shared/store/wishlist/selectors';
import { getWishlistNudgeCount } from 'shared/store/app/selectors';

// actions
import { updateShowAnimationForProductId } from 'shared/store/wishlist/actions';
import { setShowWishlistNudge } from 'shared/store/app/actions';

// services
import { addToWishlist, removeFromWishlist } from 'shared/store/wishlist/services';

// helpers
import { getWishlistEnabled } from './helper';

// components
import Wishlist from './wishlist';

const mapStateToProps = (state: any, props: any) => ({
  isLoggedInUser: isLoggedIn(state),
  isUserFetching: isUserFetching(state),
  wishlistEnabled: getWishlistEnabled(getRemoteConfig(state, 'wishlist')),
  isWishListProduct: isProductInWishlist(state, props.productId),
  showAnimationForProductId: getShowAnimationForProductId(state),
  wishlistNudgeCount: getWishlistNudgeCount(state),
});

const mapDispatchToProps = {
  showWishlistNudge: setShowWishlistNudge,
  updateShowAnimationForProductId,
  addToWishlist,
  removeFromWishlist,
};

export default connect(mapStateToProps, mapDispatchToProps)(Wishlist);
